<template>
  <div class="skeleton-loader">
    <div
      v-for="(item, index) in shapes"
      :key="index"
      :class="getShapeClass(item.type)"
      :style="{ width: item.width, height: item.height, borderRadius: item.borderRadius }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "SkeletonLoading",
  props: {
    shapes: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    getShapeClass(type) {
      return {
        'skeleton-circle': type === 'circle',
        'skeleton-line': type === 'line',
        'skeleton-rectangle': type === 'rectangle',
      };
    },
  },
};
</script>

<style scoped>
/* Base styles for the skeleton loader */
.skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Basic skeleton styles */
.skeleton-line,
.skeleton-circle,
.skeleton-rectangle {
  background: #e0e0e0;
  position: relative;
  overflow: hidden;
}

/* Shimmer effect */
.skeleton-line::before,
.skeleton-circle::before,
.skeleton-rectangle::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
  animation: shimmer 1.5s infinite;
}

/* Circle skeleton */
.skeleton-circle {
  border-radius: 50%;
}

/* Shimmer keyframes */
@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>
